import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon, MenuIcon, SearchIcon, XIcon } from 'lucide-react';
import { headerNav } from '../data/siteNav';
import { prototypeNavigate } from '../utils/prototypeNav';
import { I9Logo } from './I9Logo';
export function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [zip, setZip] = useState('');
  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    prototypeNavigate('Find a Program', `/find-a-program${zip ? `?zip=${zip}` : ''}`);
  };
  return <header className="relative z-40 w-full bg-white" data-id="element-195" data-mp="14w5993ijzwjv">
      <div className="relative flex h-14 items-center justify-between px-4 lg:px-8" data-id="element-196" data-mp="14xzs8ca9lelb">
        <a href="/" onClick={e => {
        e.preventDefault();
        prototypeNavigate('Home', '/');
      }} className="relative z-10 lg:absolute lg:left-6 lg:top-2" data-id="element-197" data-mp="zwkaou7apq7o">
          <I9Logo data-id="element-198" data-mp="2bch7f4ldlefg" />
        </a>
        <nav aria-label="Main" className="ml-auto hidden lg:block" data-id="element-199" data-mp="2bbfm87anbbk0">
          <ul className="flex items-center gap-8" data-id="element-200" data-mp="29k2cungidzy5">
            {headerNav.map(item => <li key={item.label} data-id="element-201" data-mp="2eiwrrebcv4cz">
                <a href="#" onClick={e => e.preventDefault()} className="flex items-center gap-1 whitespace-nowrap text-xs font-semibold uppercase text-brand-navy transition-colors duration-150 hover:text-brand-red" data-id="element-202" data-mp="2ehvi9e9zmpxd">
                  {item.label}
                  {item.hasMenu && <ChevronDownIcon className="h-3 w-3" aria-hidden="true" data-id="element-203" data-mp="1qr7vxnzbrxra" />}
                </a>
              </li>)}
          </ul>
        </nav>
        <button type="button" onClick={() => setMenuOpen(o => !o)} aria-expanded={menuOpen} aria-label={menuOpen ? 'Close menu' : 'Open menu'} className="rounded-sm p-2 text-brand-navy lg:hidden" data-id="element-204" data-mp="20r8lhrnsfa3x">
          {menuOpen ? <XIcon className="h-6 w-6" data-id="element-205" data-mp="1d1ny8wklpqou" /> : <MenuIcon className="h-6 w-6" data-id="element-206" data-mp="1d0w29kn3dqy1" />}
        </button>
      </div>

      <div className="flex h-11 items-center bg-brand-navy pl-4 lg:pl-0" data-id="element-207" data-mp="150yh6vvkxex6">
        <form onSubmit={submit} className="flex flex-1 items-center gap-3 lg:justify-center" data-id="element-208" data-mp="14yvfhel2dxcm">
          <label htmlFor="header-zip" className="hidden whitespace-nowrap text-xs font-bold uppercase tracking-wide text-white sm:block" data-id="element-209" data-mp="1002c4ezhrmq6">
            Find a program near you
          </label>
          <div className="flex" data-id="element-210" data-mp="19sq50yncp6jm">
            <input id="header-zip" inputMode="numeric" maxLength={5} value={zip} onChange={e => setZip(e.target.value.replace(/\D/g, ''))} placeholder="ZIP code" aria-label="ZIP code" className="h-7 w-28 rounded-l-sm border-0 px-2 text-sm text-brand-ink placeholder:text-brand-muted focus:outline-none focus:ring-2 focus:ring-brand-sky" data-id="element-211" data-mp="m23yjbszvubq" />
            <button type="submit" aria-label="Search programs" className="flex h-7 w-8 items-center justify-center rounded-r-sm bg-brand-red text-white transition-colors duration-150 hover:bg-brand-redDark" data-id="element-212" data-mp="27htao5qsu3on">
              <SearchIcon className="h-3.5 w-3.5" data-id="element-213" data-mp="2a2hj1xc8beo7" />
            </button>
          </div>
        </form>
        <a href="#" onClick={e => e.preventDefault()} className="hidden items-center gap-1 whitespace-nowrap px-4 text-xs text-white md:flex" data-id="element-214" data-mp="2ewv71eokajiu">
          Login / Sign up <ChevronDownIcon className="h-3 w-3" aria-hidden="true" data-id="element-215" data-mp="251tjgn9xppid" />
        </a>
        <a href="#" onClick={e => e.preventDefault()} className="flex h-full items-center whitespace-nowrap bg-brand-red pl-7 pr-4 text-xs font-medium text-white [clip-path:polygon(18px_0,100%_0,100%_100%,0_100%)] lg:pr-8" data-id="element-216" data-mp="2sqcqz0l5ty9e">
          Franchise Info
        </a>
      </div>

      <AnimatePresence data-id="element-217" data-mp="2nyl9dfjzf2ve">
        {menuOpen && <motion.nav aria-label="Mobile" initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -8
      }} transition={{
        duration: 0.18,
        ease: [0.23, 1, 0.32, 1]
      }} className="absolute inset-x-0 top-full border-t border-brand-line bg-white shadow-lg lg:hidden" data-id="element-218" data-mp="3bpib5zi2cjsx">
            <ul className="divide-y divide-brand-line" data-id="element-219" data-mp="1nrhhvpn6y2ci">
              {headerNav.map(item => <li key={item.label} data-id="element-220" data-mp="1itzgqlff0rf2">
                  <a href="#" onClick={e => e.preventDefault()} className="flex items-center justify-between px-5 py-3.5 text-sm font-semibold uppercase text-brand-navy" data-id="element-221" data-mp="1esdxmicafgwf">
                    {item.label}
                    {item.hasMenu && <ChevronDownIcon className="h-4 w-4" aria-hidden="true" data-id="element-222" data-mp="26kbmbpn6uc2h" />}
                  </a>
                </li>)}
              <li data-id="element-223" data-mp="21qqtsd4d6aao">
                <a href="#" onClick={e => e.preventDefault()} className="block px-5 py-3.5 text-sm text-brand-navy" data-id="element-224" data-mp="21q7hbbxhge41">Login / Sign up</a>
              </li>
            </ul>
          </motion.nav>}
      </AnimatePresence>
    </header>;
}